import { SecurityCheckPoint } from './SecurityCheckPoint';

export class SecurityCheckModel {
  public CheckPoints: SecurityCheckPoint[] = [];

  public Remarks: string = "";

  constructor(checkPointsData: any[] = []) {
    // Map the API response to the SecurityCheckPoint class
    this.CheckPoints = checkPointsData.map(cp => new SecurityCheckPoint(cp));
  }
  public get IsValid(): boolean {
    return this.CheckPoints.some(x => !x.Ok && !x.Failed);
  }

  public get HasDeviation(): boolean {
    return this.CheckPoints.some(x => x.Failed);
  }
}
